module.exports = __webpack_public_path__ + "src/images/products/active/13_Summer Rebel Logo Tee.png";